// src/helpers/parse-attributes.js

function parseAttributes(str) {
  // アトリビュートの文字列をパースする：
  //   例: val1=value1 val2="value2 with quote" => { val1: 'value1', val2: 'value2 with quote' }
  var r
  var result = {}
  while (r = str.match(/^([-a-z]+)=(['"](.*?)["']|([^'" ]+))/)) { // "'
    result[r[1]] = r[2].replace(/^['"]?(.*?)["']?$/, "$1")
    str = str.slice(r[0].length).trim()
  }
  return result
}

export default parseAttributes



// WEBPACK FOOTER //
// ./src/helpers/parse-attributes.js